import React, { useState } from "react";
import useApi from "../../utils/useApi";

const CsvUploader = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const { PostFile } = useApi();

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setLogs([]);
    setLoading(true);

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await PostFile("createTransactionsFromCSV", formData); // 👈 Use your actual API key here
      setLogs([`✅ ${response.data.message || "File uploaded successfully."}`]);
    } catch (error) {
      if (error.response?.data?.error) {
        setLogs([`❌ Upload failed: ${error.response.data.error}`]);
      } else {
        setLogs([`❌ Upload failed: ${error.message}`]);
      }
    }

    setLoading(false);
  };

  return (
    <div
      style={{
        border: "2px solid black",
        margin: "10px",
        padding: "10px",
        backgroundColor: "lightyellow",
      }}
    >
      <h6 className="text-xl font-bold mb-4">
        Mass Transaction Upload (CSV to DB)
      </h6>
      <input type="file" accept=".csv" onChange={handleFileChange} />
      {loading && <p>⏳ Uploading...</p>}
      <ul>
        {logs.map((log, i) => (
          <li key={i}>{log}</li>
        ))}
      </ul>
    </div>
  );
};

export default CsvUploader;
